export default "__VITE_ASSET__Bed44Rwn__"